import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MyButton from '../../../utils/MyButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import CircularProgress from '@material-ui/core/CircularProgress';

import { FaArrowLeft, FaTools, FaPuzzlePiece } from "react-icons/fa";

import './AccesoriosActivo.css'

export class AccesoriosActivo extends Component {
  state = {
    open: false
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  // Helper method to check if equipment has any accessories
  hasAccessories() {
    const { mobiliario } = this.props;
    return mobiliario && (
      mobiliario.accesorio === true || 
      (mobiliario.accesorionombre1 && mobiliario.accesorionombre1.trim() !== '') ||
      (mobiliario.accesorionombre2 && mobiliario.accesorionombre2.trim() !== '') ||
      (mobiliario.accesorionombre3 && mobiliario.accesorionombre3.trim() !== '')
    );
  }

  render() {
    const { UI: { loading }, mobiliario } = this.props;
    const hasAccessories = this.hasAccessories();

    return (
      <div>
        <Fragment>
          <MyButton
            tip="Accesorios del mobiliario"
            onClick={this.handleOpen}
          >
            <FaTools color="#03178C" className="icon-crearcliente" />
          </MyButton>

          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>
              <div className='container-title-recomendaciones'>
                <h2 className='title-recomendaciones'>Accesorios del mobiliario</h2>
              </div>
            </DialogTitle>

            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress-recomendation-uso" />
            ) : (
              <div>
                <DialogContent>
                  <div className='container-recomendaciones'>
                    {/* Mostrar accesorios si existen */}
                    {hasAccessories ? (
                      <div className="accesorios-existentes">
                        <div className="seccion-cabecera">
                          <FaTools className="icon-seccion" />
                          <Typography variant="h6" className="seccion-titulo">
                            Accesorios registrados
                          </Typography>
                        </div>
                        
                        <div className="accesorios-container">
                          {/* Indicador general de accesorios */}
                          {mobiliario.accesorio === true && (
                            <div className="accesorios-indicator">
                              <p className="recomendacion-text">El mobiliario incluye accesorios</p>
                            </div>
                          )}

                          {/* Lista de accesorios */}
                          {(mobiliario.accesorionombre1 || mobiliario.accesorionombre2 || mobiliario.accesorionombre3) && (
                            <div className="accesorios-lista">
                              
                              {/* Accesorio 1 */}
                              {mobiliario.accesorionombre1 && mobiliario.accesorionombre1.trim() !== '' && (
                                <div className="accesorio-item">
                                  <h3 className="accesorio-titulo">{mobiliario.accesorionombre1}</h3>
                                  <div className="accesorio-details">
                                    <div className="accesorio-detail-item"><strong>Referencia:</strong> {mobiliario.accesorioref1 || 'No especificada'}</div>
                                    <div className="accesorio-detail-item"><strong>Serie:</strong> {mobiliario.accesorioserie1 || 'No especificada'}</div>
                                  </div>
                                </div>
                              )}

                              {/* Accesorio 2 */}
                              {mobiliario.accesorionombre2 && mobiliario.accesorionombre2.trim() !== '' && (
                                <div className="accesorio-item">
                                  <h3 className="accesorio-titulo">{mobiliario.accesorionombre2}</h3>
                                  <div className="accesorio-details">
                                    <div className="accesorio-detail-item"><strong>Referencia:</strong> {mobiliario.accesorioref2 || 'No especificada'}</div>
                                    <div className="accesorio-detail-item"><strong>Serie:</strong> {mobiliario.accesorioserie2 || 'No especificada'}</div>
                                  </div>
                                </div>
                              )}

                              {/* Accesorio 3 */}
                              {mobiliario.accesorionombre3 && mobiliario.accesorionombre3.trim() !== '' && (
                                <div className="accesorio-item">
                                  <h3 className="accesorio-titulo">{mobiliario.accesorionombre3}</h3>
                                  <div className="accesorio-details">
                                    <div className="accesorio-detail-item"><strong>Referencia:</strong> {mobiliario.accesorioref3 || 'No especificada'}</div>
                                    <div className="accesorio-detail-item"><strong>Serie:</strong> {mobiliario.accesorioserie3 || 'No especificada'}</div>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="no-accesorios">
                        <Typography variant="h6" className="no-accesorios-titulo">
                          Sin accesorios registrados
                        </Typography>
                        <Typography variant="body1" className="no-accesorios-mensaje">
                          Este mobiliario no tiene accesorios adicionales registrados en el sistema.
                        </Typography>
                        <Typography variant="body2" className="no-accesorios-sugerencia">
                          Puede agregar accesorios al editar la información del mobiliario. En la función Editar.
                        </Typography>
                      </div>
                    )}
                  </div>
                </DialogContent>
              </div>
            )}

            <DialogActions>
              <MyButton tip="Cerrar" onClick={this.handleClose}>
                <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
              </MyButton>
            </DialogActions>

          </Dialog>
        </Fragment>
      </div >
    )
  }
}

AccesoriosActivo.propTypes = {
  UI: PropTypes.object.isRequired,
  tipouser: PropTypes.string.isRequired,
  mobiliario: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  mobiliario: state.dataMob.mobiliario.credentials,
  UI: state.UI,
  tipouser: state.user.credentials.tipouser,
});

export default connect(mapStateToProps)(AccesoriosActivo);